<script setup>
import Jumbo from '@/components/Docs/Jumbo.vue'
import DocSection from '@/components/Docs/Section.vue'
import CodeBlock from '@/components/Docs/CodeBlock.vue'
import JsonBlock from '@/components/Docs/JsonBlock.vue'
  
</script>

<template>
  <div class="wrap row">
    <jumbo title="Artifact">
As part of our effort to create relations between web resources, we extract a host of different artifacts from all the URLs that we visit. These include, but are not limited to, website trackers, analytics ids, social media handles, hashes, emails,  and API keys. Using the following endpoints, one can get an overview of which sites and domains, and IPs any given artifact has been observed on.
    </jumbo>


    <doc-section title="Get number of observations">
      <template v-slot:left>
This endpoint is queried using a POST request, with a json body. The json should naturally be valid, and have a key named “inputs” which should be an array of no more than 100 strings. These strings are matched against all known artifacts. 
<br><br>
The response is an object with all artifacts with results as keys, with the corresponding value being the number of ips and domains respectively. It should be noted that if one of the input strings is not present in the output, it means we have not seen it yet.

      </template>

      <template v-slot:right>
        <code-block title="/relations/artifact/count" :json="true" method="POST">
          {
            "inputs": [ "_gid", "UA-18003-7", "GA1.2.132449554.1710357739" ]
          }
        </code-block>

        <json-block title="Response">
{
    "data": {
        "GA1.2.132449554.1710357739": {
            "domains": 1,
            "ips": 1
        },
        "UA-18003-7": {
            "domains": 2,
            "ips": 17
        },
        "_gid": {
            "domains": 68325,
            "ips": 40886
        }
    },
    "status": "success"
}
        </json-block>
      </template>
    </doc-section>


    <doc-section title="Get observations">
      <template v-slot:left>
This endpoint is queried using a POST request, with a json body. The json should have a key named “input” which should be a string, the string has a maximum length of 400 characters. 
<br><br>
The response is an object containing a list of relations. Each of them contains the domain and ip of the site on which it was seen, as well as the timestamp of when it was observed.

      </template>

      <template v-slot:right>
        <code-block title="/relations/artifact" :json="true" method="POST">
          {
            "inputs": "GA1.2.132449554.1710357739"
          }
        </code-block>

        <json-block title="Response">

{
    "data": {
        "Artifact": "GA1.2.132449554.1710357739",
        "Relations": [
            {
                "Domain": "creaciondigitalonline.com.creaciondigital.site",
                "IP": "174.34.132.83",
                "Time": "2024-03-13T19:39:40.162616Z"
            },
            {
                "Domain": "creaciondigitalonline.com",
                "IP": "174.34.132.83",
                "Time": "2024-03-13T19:39:13.568589Z"
            }
        ]
    },
    "status": "success"
}

        </json-block>



      
      </template>
    </doc-section>

  </div>
</template>

<style scoped>
.wrap {
  height: 100%;
  overflow-y: scroll;
}

.wrap > * {
  margin-top: 2.5rem;
}
.wrap > *:not(:first-child) {
  border-top: 2px solid #1e252f;
  padding-top: 2.5rem;
}
</style>
